import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: '消防ソリューション',

  banner: {
    title: 'データを活用して消防訓練の成果を正確に検証しましょう。',
    desc: '消防隊員の位置をリアルタイムで追跡し、訓練の正確性を客観的に評価して、運用効率を最大化します。',
  },

  // video: {
  //   title: '標準化された手順に基づき、事故を自動検知して迅速に対応',
  //   desc: '作業員の動線や危険要素をリアルタイムで検知し、SOPに基づいて自動で通知・記録・対応まで連携し、安全対策を体系化します。データは自動で保存され、将来の分析や監査にも役立ちます。',
  //   play: mainVideo,
  // },

  summary: {
    function: {
      title: '消防訓練の正確な評価と効率的な管理をデジタル化。',
      desc: '消防隊員のリアルタイム位置データを基に、訓練のプロセスと成果を客観的に分析し、効率的に管理します。',
      card: [
        {
          image: '',
          title: '移動経路ヒートマップの可視化',
          desc: '消防隊員の詳細な移動経路と動線をデータとして正確に記録し、訓練目標の達成状況を評価します。実際の移動データを基に、訓練の正確性を分析し、改善点を明確化します。',
        },
        {
          title: '詳細な移動経路データ分析',
          desc: '消防隊員の詳細な移動経路と動線をデータとして正確に記録し、訓練目標の達成状況を評価します。実際の移動データを基に、訓練の正確性を分析し、改善点を明確化します。',
        },
        {
          title: '高精度の位置データ受信を確保',
          desc: 'TwinTrackerを活用し、消防隊員の位置データをリアルタイムかつ誤差なく受信・記録します。訓練中の正確な移動経路と位置分析が可能となり、評価の信頼性が向上し、効率的な運用管理を支援します。',
        },
        {
          title: 'リアルタイム統合運用モニタリング',
          desc: '現場に設置されたTwinTrackerを活用し、訓練空間全体をリアルタイムで一元管理し、進行状況を迅速に把握して、運用効率と対応速度を高めます。',
        },
      ],
    },
  },

  numOfCard: {
    title: 'データを基にした消防訓練評価で運用効率を最大化',
    desc: '客観的な訓練データで現場運用を正確かつ効果的に改善します。',
    card: [
      {
        tag: '97%',
        title: '訓練移動経路自動記録の精度',
        desc: '訓練中の消防隊員の移動経路と位置をリアルタイムで正確に記録し、評価の信頼性を最大化します。',
      },
      {
        tag: '95%',
        title: 'リアルタイム位置追跡およびカバレッジ',
        desc: '訓練施設内の全エリアと隊員を漏れなくカバーし、完璧なリアルタイムモニタリングを実現します。',
      },
      {
        tag: '99%',
        title: '現場とデジタルマップの構造一致率',
        desc: '現場構造をデジタルマップに正確に反映し、実際の訓練場と完全に一致させます。',
      },
    ],
  },

  func: [
    {
      theme: '消防隊員の位置追跡機能で<br/>訓練の正確性を高める。',
      title: 'TwinTrackerの現場最適設置による高精度追跡',
      desc: '訓練場内の地下鉄車両、階段、通路などの構造を分析し、TwinTrackerを最適な位置に設置します。現場特性を考慮した配置と効率的な構成で、消防隊員の位置を誤差なく正確に追跡します。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '現場設置TwinTrackerによる正確なデータ受信',
      desc: '現場に設置されたTwinTrackerは、地下鉄内部や複雑な構造内でも干渉なく正確な位置データを安定的に受信します。高い受信精度により、消防隊員のリアルタイム位置情報を信頼性高く提供します。',
      sub1: '迅速なデータ連携',
      icon1: IconBinocularsGray,
      sub2: 'リアルタイム位置追跡',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '現場構造に基づくデジタル位置追跡環境',
      desc: '訓練場の実際の構造や地下鉄車両などをそのままデジタルマップに再現し、消防隊員の動きを直感的にモニタリングします。構造物や障害物も正確に反映し、現場とデジタル画面の一致性を高め、正確なリアルタイム位置データを確保します。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '設計図から3D可視化まで、一貫した追跡ソリューション構築',
      desc: 'TwinTrackerの設置は正確な設計図に基づいて行われ、現場写真で設置状況を確認できます。直感的なモニタリング画面とリアルな3D可視化で、設置から運用まで一貫した位置追跡ソリューションを提供します。',
      sub1: '自由なエリア設定',
      icon1: IconZoneGray,
      sub2: '複数エリア管理',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  customer: {
    title: 'ORBROを導入したお客様のリアルな声',
    card: [
      {
        desc: 'これまでの消防訓練は経験や直感に頼る評価が主でしたが、ORBROのリアルタイム位置追跡システムの導入により、消防隊員の訓練過程や移動経路を正確に把握できるようになりました。訓練結果を客観的なデータで即確認できるため、評価の信頼性と効率が大幅に向上しました。今後の現場活動にも大きく役立つと期待しています。',
        name: 'ソウル特別市消防災難本部',
      },
    ],
  },

  subfunc: {
    title: '主な機能概要',
    desc: '作業者の安全を確保することは、効率を高め、事故による損失を減少させます。ORBROは建設現場の作業者の安全を守るために最適な機能を提供しています。作業者が危険区域に接近した場合や事故が発生した際、または重機による潜在的リスクを含む様々な安全状況に対し、適切に対応できるシステムを構築しています。',

    data: [
      {
        icon: IconLocation,
        title: 'リアルタイム位置追跡',
        desc: '現場内で消防隊員の位置をリアルタイムで正確に追跡します。',
      },
      {
        icon: IconChartBar,
        title: '高精度設置とデータ受信',
        desc: '現場に最適化された設置で位置データの正確性と安定性を確保します。',
      },
      {
        icon: IconAnalytics,
        title: '移動経路ヒートマップ可視化',
        desc: '訓練中に活動が集中するエリアをヒートマップとして直感的に確認できます。',
      },
      {
        icon: IconRoute,
        title: '訓練移動経路の自動記録',
        desc: '消防隊員の移動経路を自動で記録し、客観的なデータ評価を可能にします。',
      },
      {
        icon: IconLayers,
        title: '現場構造のデジタルマップ化',
        desc: '実際の訓練現場構造をそのままデジタルマップに再現し、一致性を最大化します。',
      },
      {
        icon: IconLayers,
        title: '3Dベースの訓練管理',
        desc: '3Dモデルを用いて訓練進行状況を明確に可視化します。',
      },
      {
        icon: IconLocation,
        title: '信頼性の高い位置データ受信',
        desc: '構造物や地下鉄車両など複雑な環境でも干渉なく安定した位置データを提供します。',
      },
      {
        icon: IconSearch,
        title: '設計図連動管理',
        desc: '設計図からモニタリング、3D可視化まで一貫した位置追跡ソリューションを構築します。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
